import { Box, Paper, Grid, Typography } from '@mui/material';
import { Person as PersonIcon, CalendarToday as DateIcon, Class as GradeIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const InfoItem = ({ icon, label, value }) => (
  <Box display="flex" flexDirection="column" gap={0.5}>
    <Box display="flex" alignItems="center" gap={1} color="text.secondary">
      {icon}
      <Typography variant="caption" fontWeight="bold" textTransform="uppercase">
        {label}
      </Typography>
    </Box>
    <Typography variant="body1" fontWeight="500">
      {value ?? "—"}
    </Typography>
  </Box>
);

export default function StudentProfileCard({ student }) {
  const { t } = useTranslation();
  const studentName = [
    student?.firstName,
    student?.middleName,
    student?.lastName
  ].filter(Boolean).join(" ");

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        bgcolor: 'background.paper',
        borderRadius: 2,
        mb: 0,
        border: '1px solid divider'
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <InfoItem
            icon={<PersonIcon fontSize="small" />}
            label={t("Full Name")}
            value={studentName || "—"}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <InfoItem
            icon={<DateIcon fontSize="small" />}
            label={t("Date of Birth")}
            value={student?.dateOfBirth ? dayjs(student.dateOfBirth).format("MMMM D, YYYY") : "—"}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <InfoItem
            icon={<GradeIcon fontSize="small" />}
            label={t("Grade Applying")}
            value={student?.gradeApp}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
